// test974
(974 && 0);
